<template>




</template>

<script>
export default {
    name: "View.vue"
}
</script>

<style scoped>

</style>
